import React from "react";

const ListingsPage = ({ 
  listings, 
  setShowAddListingModal, 
  handleEditListing, 
  handleFlagListing, 
  toggleFeatured 
}) => {
  return (
    <div className="space-y-8">
      {/* Header with Add Button */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h2 className="dark-header !text-[#000]">My Listings</h2>
          <p className="light-header">Manage and track your property listings</p>
        </div>
        <button 
          onClick={() => setShowAddListingModal(true)}
          className="flex items-center px-6 py-3 bg-gradient-to-r from-[#10c9c0] to-[#0eb1a9] text-white rounded-xl hover:from-[#0eb1a9] hover:to-[#10c9c0] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
        >
          <i className="fas fa-plus mr-2"></i>
          Add New Listing
        </button>
      </div>

      {/* Listings Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
        {listings.map((listing) => (
          <div key={listing.property_id} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
            {/* Image Section */}
            <div className="h-48 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center relative overflow-hidden">
              {listing.Images && listing.Images.length > 0 ? (
                <img 
                  src={listing.Images[0]} 
                  alt={listing.Address}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div className="w-full h-full flex items-center justify-center">
                <i className="fas fa-building text-4xl text-gray-400"></i>
              </div>
              
              {listing.featured && (
                <div className="absolute top-4 right-4 bg-gradient-to-r from-[#10c9c0] to-[#0eb1a9] text-white px-3 py-1 rounded-full text-sm font-medium">
                  <i className="fas fa-star mr-1"></i>
                  Featured
                </div>
              )}
              <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-sm font-medium ${
                listing.status === 'active' ? 'bg-emerald-100 text-emerald-800' :
                listing.status === 'flagged' ? 'bg-red-100 text-red-800' :
                'bg-gray-100 text-gray-800'
              }`}>
                {listing.status || 'active'}
              </div>
            </div>
            
            <div className="p-6">
              <h3 className="dark-header !text-[#000] !mb-3 !text-lg">{listing.Address}</h3>
              
              <div className="space-y-3 mb-6">
                <div className="flex items-center text-[#949995]">
                  <i className="fas fa-map-marker-alt w-5 mr-2"></i>
                  <span className="light-header !mb-0">{listing.Address}</span>
                </div>
                <div className="flex items-center text-[#10c9c0]">
                  <i className="fas fa-yen-sign w-5 mr-2"></i>
                  <span className="font-bold text-lg">¥{parseInt(listing.Price.replace(/\D/g, '')).toLocaleString()}</span>
                </div>
                <div className="flex items-center space-x-6 text-[#949995]">
                  <div className="flex items-center">
                    <i className="fas fa-calendar mr-1"></i>
                    <span className="light-header !mb-0">{listing.Year_of_Construction}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="fas fa-home mr-1"></i>
                    <span className="light-header !mb-0">{listing.Empty_or_Not}</span>
                  </div>
                  <div className="flex items-center">
                    <i className="fas fa-ruler-combined mr-1"></i>
                    <span className="light-header !mb-0">{listing.Area_of_House}</span>
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-3 gap-2 mt-6">
                <button 
                  onClick={() => handleEditListing(listing)}
                  className="flex items-center justify-center py-2 px-3 bg-[#10c9c0] text-white rounded-lg hover:bg-[#0eb1a9] transition-colors text-sm"
                >
                  <i className="fas fa-edit mr-1"></i>
                  Edit
                </button>
                <button 
                  onClick={() => toggleFeatured(listing.property_id)}
                  className={`flex items-center justify-center py-2 px-3 rounded-lg transition-colors text-sm ${
                    listing.featured 
                      ? 'bg-[#10c9c0] text-white hover:bg-[#0eb1a9]' 
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                >
                  <i className="fas fa-star mr-1"></i>
                  {listing.featured ? 'Featured' : 'Feature'}
                </button>
                <button 
                  onClick={() => handleFlagListing(listing.property_id)}
                  className={`flex items-center justify-center py-2 px-3 rounded-lg transition-colors text-sm ${
                    listing.status === 'flagged'
                      ? 'bg-red-500 text-white hover:bg-red-600'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                >
                  <i className="fas fa-flag mr-1"></i>
                  {listing.status === 'flagged' ? 'Unflag' : 'Flag'}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListingsPage;